(function () {
  if (window.__nfCluster) return;
  window.__nfCluster = true;

  // Edge of each shape in unit space, as a radius for angle t (y grows downward)
  var SHAPES = {
    lem: function (t) {
      var c = Math.cos(t), s = Math.sin(t) / 0.62;
      return (1 / Math.sqrt(c * c + s * s)) * (1 + 0.2 * Math.pow(Math.abs(Math.cos(t)), 16));
    },
    avo: function (t) {
      var c = Math.cos(t) / 0.7, s = Math.sin(t);
      return (1 / Math.sqrt(c * c + s * s)) * (1 + 0.17 * Math.sin(t));
    },
    berri: function (t) { return 0.92 * (1 + 0.05 * Math.sin(9 * t + 0.4)); }
  };

  function inside(fn, x, y) {
    var r = Math.sqrt(x * x + y * y);
    return r === 0 || r <= fn(Math.atan2(y, x));
  }

  // Horizontal extent of the shape at unit height y, or null outside it
  function chord(fn, y) {
    var L = null, R = null;
    for (var x = -1.4; x <= 1.4; x += 0.01) {
      if (inside(fn, x, y)) { if (L === null) L = x; R = x; }
    }
    return L === null ? null : [L, R];
  }

  function bounds(fn) {
    var top = null, bot = null, wide = 0;
    for (var y = -1.4; y <= 1.4; y += 0.01) {
      var c = chord(fn, y);
      if (c) { if (top === null) top = y; bot = y; wide = Math.max(wide, c[1] - c[0]); }
    }
    return { top: top, bot: bot, wide: wide };
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }

  function Cluster(root) {
    this.root = root;
    this.stage = root.querySelector('.nf-cluster__stage');
    this.list = root.querySelector('.nf-cluster__list');
    this.card = root.querySelector('.nf-cluster__card');
    this.controls = root.querySelector('.nf-cluster__controls');
    this.shape = root.getAttribute('data-shape') || 'lem';
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.bounds = {};
    this.hover = null;
    this.mouse = null;
    this.running = false;
    this.visible = true;
    var self = this;
    this.nodes = Array.prototype.map.call(root.querySelectorAll('.nf-cl'), function (el, i) {
      return { el: el, link: el.querySelector('a.nf-cl__name'), x: 0, y: 0, vx: 0, vy: 0, s: 1, p: i * 1.7, w: 0, h: 0, tx: 0, ty: 0 };
    });
    this.order = shuffle(this.nodes.slice());
    root.classList.add('is-live');
    if (this.controls) this.controls.hidden = false;
    this.markShape();
    this.measure();
    this.layout(true);
    this.bind();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        self.visible = es[0].isIntersecting;
        if (self.visible) self.start();
      }).observe(this.stage);
    }
    this.start();
  }

  Cluster.prototype.measure = function () {
    this.nodes.forEach(function (n) { n.w = n.el.offsetWidth; n.h = n.el.offsetHeight; });
    var hs = this.nodes.filter(function (n) { return !n.el.classList.contains('nf-cl--img'); }).map(function (n) { return n.h; });
    this.lineH = (hs.length ? Math.max.apply(null, hs) : 24) + 4;
  };

  // Pack names into the shape row by row; returns how many fit at vertical scale sy
  Cluster.prototype.fill = function (fn, b, sx, sy, commit) {
    var lh = this.lineH, gap = 10, order = this.order, i = 0;
    var top = b.top * sy, bot = b.bot * sy, W = this.width;
    for (var y = top; y + lh <= bot + 0.5 && i < order.length; y += lh) {
      var c1 = chord(fn, y / sy), c2 = chord(fn, (y + lh) / sy);
      if (!c1 || !c2) continue;
      var L = Math.max(c1[0], c2[0]) * sx, R = Math.min(c1[1], c2[1]) * sx;
      var room = R - L, used = 0, row = [];
      while (i < order.length && used + order[i].w + (row.length ? gap : 0) <= room) {
        used += order[i].w + (row.length ? gap : 0);
        row.push(order[i]);
        i++;
      }
      if (commit && row.length) {
        var x = W / 2 + L + (room - used) / 2;
        row.forEach(function (n) {
          n.tx = x + n.w / 2;
          n.ty = y - top + lh / 2 + 8;
          x += n.w + gap;
        });
      }
    }
    return i;
  };

  Cluster.prototype.layout = function (first) {
    this.width = this.stage.clientWidth;
    var narrow = this.width < 600, base = SHAPES[this.shape] || SHAPES.lem;
    // On phones the lemon stands upright so it fits the screen
    var rot = narrow && this.shape === 'lem';
    var fn = rot ? function (t) { return base(t - Math.PI / 2); } : base;
    var key = this.shape + (rot ? '-r' : '');
    var b = this.bounds[key] || (this.bounds[key] = bounds(fn));
    var Hmax = narrow ? Math.max(560, window.innerHeight * 0.95) : Math.min(820, Math.max(560, window.innerHeight * 0.9));
    // Keep the shape's own proportions: one scale for both axes, a little vertical stretch allowed
    var S = Math.min((this.width - 8) / b.wide, Hmax / (b.bot - b.top));
    var sx = S, minY = S * 0.8, maxY = S * (narrow ? 1.9 : 1.35), n = this.order.length;
    // Everyone shares one type size: the biggest that fits
    for (var fs = 1.15; fs >= 0.7; fs -= 0.05) {
      this.root.style.setProperty('--nf-cl-scale', fs.toFixed(2));
      this.measure();
      if (this.fill(fn, b, sx, maxY, false) >= n) break;
    }
    while (this.fill(fn, b, sx, maxY, false) < n) maxY *= 1.15;
    var lo = minY, hi = maxY;
    if (this.fill(fn, b, sx, lo, false) >= n) hi = lo;
    else for (var k = 0; k < 20; k++) {
      var mid = (lo + hi) / 2;
      if (this.fill(fn, b, sx, mid, false) >= n) hi = mid; else lo = mid;
    }
    this.fill(fn, b, sx, hi, true);
    this.list.style.height = Math.ceil((b.bot - b.top) * hi + this.lineH + 16) + 'px';
    var self = this;
    this.nodes.forEach(function (nd) {
      if (first) {
        if (self.reduce) { nd.x = nd.tx; nd.y = nd.ty; }
        else { nd.x = self.width / 2 + (Math.random() - 0.5) * 40; nd.y = parseFloat(self.list.style.height) / 2 + (Math.random() - 0.5) * 40; }
      } else if (!self.reduce) {
        nd.vx += (Math.random() - 0.5) * 6; nd.vy += (Math.random() - 0.5) * 6;
      } else { nd.x = nd.tx; nd.y = nd.ty; }
    });
    this.start();
  };

  Cluster.prototype.start = function () {
    if (this.running || !this.visible) return;
    this.running = true;
    var self = this;
    requestAnimationFrame(function loop(now) {
      if (!self.visible) { self.running = false; return; }
      self.tick(now);
      requestAnimationFrame(loop);
    });
  };

  Cluster.prototype.tick = function (now) {
    var drift = this.reduce ? 0 : 3, R = this.reduce ? 0 : 110, m = this.mouse, hov = this.hover;
    for (var i = 0; i < this.nodes.length; i++) {
      var n = this.nodes[i];
      var hx = n.tx + Math.sin(now * 0.0006 + n.p) * drift;
      var hy = n.ty + Math.cos(now * 0.0008 + n.p * 1.7) * drift;
      var ax = (hx - n.x) * 0.05, ay = (hy - n.y) * 0.05;
      if (m && n !== hov && R) {
        var dx = n.x - m.x, dy = n.y - m.y, d = Math.sqrt(dx * dx + dy * dy) || 1;
        if (d < R) { var f = 1 - d / R; f = f * f * 7; ax += (dx / d) * f; ay += (dy / d) * f; }
      }
      n.vx = (n.vx + ax) * 0.8; n.vy = (n.vy + ay) * 0.8;
      n.x += n.vx; n.y += n.vy;
      n.s += ((n === hov ? 1.4 : 1) - n.s) * 0.2;
      n.el.style.transform = 'translate3d(' + (n.x - n.w / 2).toFixed(1) + 'px,' + (n.y - n.h / 2).toFixed(1) + 'px,0) scale(' + n.s.toFixed(3) + ')';
    }
    if (hov) this.placeCard(hov);
  };

  Cluster.prototype.show = function (n) {
    if (!n || n.el.classList.contains('nf-cl--img')) return;
    if (this.hover && this.hover !== n) this.hover.el.classList.remove('is-hover');
    clearTimeout(this.hideT);
    this.hover = n;
    n.el.classList.add('is-hover');
    this.root.classList.add('has-hover');
    var c = this.card, name = n.el.querySelector('.nf-cl__name');
    c.querySelector('.nf-cluster__card-name').textContent = name.textContent;
    c.querySelector('.nf-cluster__card-line').textContent = n.el.getAttribute('data-line') || '';
    c.querySelector('.nf-cluster__card-met').textContent = n.el.getAttribute('data-met') || '';
    var go = c.querySelector('.nf-cluster__card-go');
    if (n.link) { go.href = n.link.getAttribute('href'); go.hidden = false; } else { go.hidden = true; }
    c.hidden = false;
    this.placeCard(n);
  };

  Cluster.prototype.hide = function (now) {
    var self = this;
    clearTimeout(this.hideT);
    this.hideT = setTimeout(function () {
      if (self.hover) self.hover.el.classList.remove('is-hover');
      self.hover = null;
      self.root.classList.remove('has-hover');
      self.card.hidden = true;
    }, now ? 0 : 260);
  };

  Cluster.prototype.placeCard = function (n) {
    var c = this.card, cw = c.offsetWidth, ch = c.offsetHeight, W = this.width;
    var left = Math.max(6, Math.min(W - cw - 6, n.x - cw / 2));
    var top = n.y - n.h * 0.8 - ch - 6;
    if (top < 0) top = n.y + n.h * 0.8 + 6;
    c.style.transform = 'translate(' + left.toFixed(0) + 'px,' + top.toFixed(0) + 'px)';
  };

  Cluster.prototype.markShape = function () {
    var shape = this.shape;
    this.root.querySelectorAll('[data-shape]').forEach(function (b) {
      if (b.tagName === 'BUTTON') b.classList.toggle('is-on', b.getAttribute('data-shape') === shape);
    });
  };

  Cluster.prototype.bind = function () {
    var self = this, touch = false;
    this.stage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = self.stage.getBoundingClientRect();
      self.mouse = { x: e.clientX - r.left, y: e.clientY - r.top - self.list.offsetTop };
    });
    this.stage.addEventListener('pointerleave', function () { self.mouse = null; self.hide(); });
    this.stage.addEventListener('pointerdown', function (e) { touch = e.pointerType !== 'mouse'; });
    this.nodes.forEach(function (n) {
      n.el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.show(n); });
      n.el.addEventListener('focusin', function () { self.show(n); });
      n.el.addEventListener('click', function (e) {
        // On touch, the first tap opens the card; a second tap follows the link
        if ((touch || !n.link) && self.hover !== n) { e.preventDefault(); self.show(n); }
      });
    });
    this.card.addEventListener('pointerenter', function () { clearTimeout(self.hideT); });
    this.card.addEventListener('pointerleave', function () { self.hide(); });
    this.root.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.hide(true); });
    document.addEventListener('pointerdown', function (e) { if (!self.stage.contains(e.target)) self.hide(true); });
    if (this.controls) this.controls.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-shuffle')) shuffle(self.order);
      else self.shape = b.getAttribute('data-shape');
      self.hide(true);
      self.markShape();
      self.layout(false);
    });
    var w = this.stage.clientWidth, t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (self.stage.clientWidth === w) return;
        w = self.stage.clientWidth;
        self.layout(false);
      }, 150);
    });
  };

  function boot() {
    document.querySelectorAll('.nf-cluster').forEach(function (root) {
      if (root.__nfc) return;
      root.__nfc = new Cluster(root);
    });
  }
  var go = function () { (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(boot); };
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
})();
